export const groupByCaffeineHour = items => {
  return Array.from(
    (items ?? [])
      .reduce((groups, item) => {
        const caffeineHour = item?.caffeineHour

        if (caffeineHour == null) return groups

        const key = String(caffeineHour)
        const group = groups.get(key) ?? { caffeineHour, items: [] }
        group.items.push(item)
        groups.set(key, group)

        return groups
      }, new Map())
      .values(),
  )
}
